module.exports = __webpack_public_path__ + "assets/img/dialog.6b69c077.png";